import { DivCards } from "../styledComponents/styledComponents";



function DivCardsComp({children}){

    return(
        <>
        <DivCards>{children}</DivCards>
        </>
    )
}

export default DivCardsComp